/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Hero_Rotate_Interview_PrepInputs */

const en_landing_hero_rotate_interview_prep = /** @type {(inputs: Landing_Hero_Rotate_Interview_PrepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`interview prep`)
};

const de_landing_hero_rotate_interview_prep = /** @type {(inputs: Landing_Hero_Rotate_Interview_PrepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interview-Prep`)
};

const fr_landing_hero_rotate_interview_prep = /** @type {(inputs: Landing_Hero_Rotate_Interview_PrepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`prépa d'entretien`)
};

const es_landing_hero_rotate_interview_prep = /** @type {(inputs: Landing_Hero_Rotate_Interview_PrepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`prep de entrevista`)
};

const it_landing_hero_rotate_interview_prep = /** @type {(inputs: Landing_Hero_Rotate_Interview_PrepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`prep al colloquio`)
};

const nl_landing_hero_rotate_interview_prep = /** @type {(inputs: Landing_Hero_Rotate_Interview_PrepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sollicitatieprep`)
};

const pl_landing_hero_rotate_interview_prep = /** @type {(inputs: Landing_Hero_Rotate_Interview_PrepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`prep do rozmowy`)
};

const fi_landing_hero_rotate_interview_prep = /** @type {(inputs: Landing_Hero_Rotate_Interview_PrepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`haastattelupreppisi`)
};

const da_landing_hero_rotate_interview_prep = /** @type {(inputs: Landing_Hero_Rotate_Interview_PrepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`interviewprep`)
};

const sv_landing_hero_rotate_interview_prep = /** @type {(inputs: Landing_Hero_Rotate_Interview_PrepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`intervjuprep`)
};

/**
* | output |
* | --- |
* | "interview prep" |
*
* @param {Landing_Hero_Rotate_Interview_PrepInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_hero_rotate_interview_prep = /** @type {((inputs?: Landing_Hero_Rotate_Interview_PrepInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Hero_Rotate_Interview_PrepInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_hero_rotate_interview_prep(inputs)
	if (locale === "fr") return fr_landing_hero_rotate_interview_prep(inputs)
	if (locale === "es") return es_landing_hero_rotate_interview_prep(inputs)
	if (locale === "it") return it_landing_hero_rotate_interview_prep(inputs)
	if (locale === "nl") return nl_landing_hero_rotate_interview_prep(inputs)
	if (locale === "pl") return pl_landing_hero_rotate_interview_prep(inputs)
	if (locale === "fi") return fi_landing_hero_rotate_interview_prep(inputs)
	if (locale === "da") return da_landing_hero_rotate_interview_prep(inputs)
	if (locale === "sv") return sv_landing_hero_rotate_interview_prep(inputs)
	return en_landing_hero_rotate_interview_prep(inputs)
});